import styled from 'styled-components';

export default styled.div`
  .gift-exchange-record-head {
    display: flex;
    flex-direction: column;
    gap: 4px 0;
    .gift-exchange-record-head-content {
      display: flex;
      align-items: center;
      gap: 0 16px;
      .gift-exchange-record-label {
        width: 58px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        flex-shrink: 0;
      }
      .gift-exchange-record-value {
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }
    }
  }
  .gift-exchange-record-info {
    display: flex;
    gap: 0 56px;
    .gift-exchange-record-info-content {
      flex: 1;
      .gift-exchange-record-info-title {
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #333330;
        line-height: 25px;
        margin-bottom: 16px;
      }
      .gift-exchange-record-info-item {
        display: flex;
        flex-direction: column;
        gap: 16px 0;
        .gift-exchange-record-info-item-content {
          display: flex;
          align-items: center;
          gap: 0 16px;
          .gift-exchange-record-label {
            width: 58px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            flex-shrink: 0;
          }
          .gift-exchange-record-label-auto {
            width: auto;
          }
          .gift-exchange-record-value {
            height: 20px;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
          }
        }
      }
    }
  }
`;
